export default "__VITE_ASSET__C6oAN0e6__"